import { createFileRoute } from '@tanstack/react-router';
import { Permission } from '../../../features/common/permision';
import { ImageGenerationPage } from '../../../features/image/image-generation.page';

export const Route = createFileRoute('/_creator-center/images/')({
  staticData: { permissions: [Permission.图片生成] },
  component: ImageGenerationPage,
});
